import {apiClient} from '../../../../lib/api-client';
import {NotificationBodyResult} from '../types/NotificationBodyResult';

export async function apiGetNotificationBody(notificationQueueID: number): Promise<NotificationBodyResult> {
    try {
        return await apiClient.get("retail-order/notification-body",
            {
                params: { notificationQueueID: notificationQueueID }
            });
    } catch (error: any) {
        return {
            isSuccess: false,
            errorMessage: error,
            data: ''
        };
    }
};
